import { AuthProvider } from '@/context/auth';
import { ConfigProvider } from '@/context/config';
import { ConnectionProvider } from '@/context/connection';
import { queryClient } from '@/lib/react-query';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Toaster } from '@/components/ui/toaster';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <ConfigProvider>
        <QueryClientProvider client={queryClient}>
          <ConnectionProvider>
            {children}
            <ToastContainer />
            <Toaster />
          </ConnectionProvider>
          {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
      </ConfigProvider>
    </AuthProvider>
  );
}
